import cx from "clsx"
import { useState } from "react"
import { Button } from "."

const CollapsibleText = props => {
  const { text, collapsibleLength = 500, className ,buttonColor} = props
  const [seeMore, setSeeMore] = useState(false)
  const finalText = text?.props?.children || text

  return (
    <>
      <p style={{ whiteSpace: "break-spaces" }} className={cx(className, "text-bw")}>
        {!seeMore && finalText?.length > collapsibleLength
          ? `${finalText?.substring(0, collapsibleLength)}...`
          : finalText}
        {finalText?.length > collapsibleLength && (
          <Button
            type="link"
            size="small"
            className="pointer text-underline pi-12 pb-0"
            style={{ height: "auto" , ...(buttonColor ? { color: buttonColor } : {})  }}
            onClick={e => {
              e?.stopPropagation()
              setSeeMore(!seeMore)
            }}
            text={seeMore ? "See Less" : "See More"}
          />
        )}
      </p>
    </>
  )
}
export default CollapsibleText
